<template>
  <nav-bar title="库管人员首页"/>
  <RoleName role="库管人员"/>
  <Content :bottom="0" :top="98">
    <!-- 入库 -->
    <div class="title">入库</div>
    <div class="loading">
      <van-loading v-if="summaryLoading.value" />
    </div>
    <ul v-if="summaryList.length" class="list">
      <li class="list-item" v-for="item in summaryList" :key="item.departmentId">
        <span class="list-item__name">{{item.departmentName}}</span>
        <span class="list-item__amount">实瓶{{item.amount}}</span>
        <van-button size="mini" :to="`/warehouseDetail/${item.departmentId}`">入库</van-button>
      </li>
    </ul>
    <Empty v-if="!summaryList.length && !summaryLoading.value" description="暂无记录" />
    <!-- 出库 -->
    <div class="title">
      <span>出库</span>
      <van-button class="btn" type="primary" size="mini" to="/codeScanningDelivery">扫码付货</van-button>
    </div>
    <div class="loading">
      <van-loading v-if="inventoryLoading.value" />
    </div>
    <ul v-if="inventoryList.length" class="list">
      <li class="list-item" v-for="item in inventoryList" :key="item.departmentId">
        <span class="list-item__name">{{item.departmentName}}</span>
        <span class="list-item__amount">实瓶{{item.cylinderCount}}</span>
        <van-button size="mini" :to="`/directPayment/${item.departmentId}`">直接付货</van-button>
      </li>
    </ul>
    <Empty v-if="!inventoryList.length && !inventoryLoading.value" description="暂无记录" />
  </Content>
</template>
<script>
import { ref, computed } from 'vue'
import { cylinderSummaryList, getInventoryList } from '@/api/cylinderManageUserHome'
import { useGetDataLoading } from '@/hooks/useGetData'
import { useStore } from 'vuex'

export default {
  name: 'WarehouseUserHome',
  setup () {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    // 获取入库列表
    const summaryList = ref([])
    const summaryLoading = ref(false)
    const summary = useGetDataLoading(cylinderSummaryList, (data) => {
      summaryList.value = data
    })
    summaryLoading.value = summary.loading
    summary.getData(
      {
        companyId: companyId.value,
        summaryType: '55'
      }
    )

    // 获取出库列表
    const inventoryList = ref([])
    const inventoryLoading = ref(false)
    const inventory = useGetDataLoading(getInventoryList, (data) => {
      inventoryList.value = data.rows
    })
    inventoryLoading.value = inventory.loading
    inventory.getData(
      {
        companyId: companyId.value,
        pageSize: 100,
        pageNumber: 1
      }
    )

    return {
      summaryLoading,
      summaryList,
      inventoryList,
      inventoryLoading
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  position: relative;
  margin: 0 16px;
  font-size: 14px;
  height: 40px;
  text-indent: 10px;
  font-weight: 600;
  &::after {
    position: absolute;
    content: '';
    width: 3px;
    background:#666;
    height: 12px;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
  .btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.list {
  padding: 0 16px;
  font-size: 14px;
  color: #666;
  .list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 14px;
    background-color: #fff;
    box-shadow: rgba(87, 107, 146, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    &__name {
      flex: 1;
    }
    &__amount {
      margin: 0 16px;
      width: 80px;
      font-weight: 600;
    }
  }
}
.loading {
  text-align: center;
}
</style>
